import React from "react";

const Loader = () => {
  return (
    <div className="loader-container !h-screen !bg-white !top-0 !left-0 !w-full">
      {Array.from({ length: 1 }).map((_, index) => (
        <div key={index} className="loader"></div>
      ))}
    </div>
  );
};

export default Loader;
